import React from 'react'
import { Box, IconButton } from '@mui/material'
import { ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material'
import moment from 'moment'
import { CustomTooltip } from 'src/designSystem'
import MeruDate from 'src/legacy/lib/MeruDate'
import { useShiftPatientProgramStartDateMutation } from './ProgramStartDateShift.generated'

type Props = {
  uid: string
  programStartDate: string
  lastWeekNbr: number
  timezone?: string | null
}

// For development purposes only
export default function ProgramStartDateShift({ uid, programStartDate, lastWeekNbr, timezone }: Props) {
  const [shiftProgramStartDate, { loading }] = useShiftPatientProgramStartDateMutation()

  const handleShift = async (days: number) => {
    const shiftedStartDate = moment.utc(programStartDate).add(days, 'days').format('YYYY-MM-DD')
    const newWeekNbr = MeruDate.now(timezone).formatWeekNumber(shiftedStartDate)
    const isPostProgram = (newWeekNbr ?? 0) > lastWeekNbr

    await shiftProgramStartDate({ variables: { uid, days, isPostProgram } })
  }

  return (
    <Box display="flex" alignItems="center">
      <CustomTooltip title="Shift program start date 1 day earlier">
        <span>
          <IconButton onClick={() => handleShift(-1)} size="small" color="primary" disabled={loading}>
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
        </span>
      </CustomTooltip>
      <CustomTooltip title="Shift program start date 1 day later">
        <span>
          <IconButton onClick={() => handleShift(1)} size="small" color="primary" disabled={loading}>
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </span>
      </CustomTooltip>
    </Box>
  )
}
